import React, { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import webSocket from 'socket.io-client'
import { SOCKETIO_URL } from '../../config';
import { setWebSocketConnect, getWebSocketConnect } from '../Login/doitSocket';
import { AddButton, Space, SubmitButton } from '../Main/Res/BaseButton';
import { SingleMultilineText, SingleTextArea } from '../Main/Res/BaseInput';
import { IR_CREATE, IR_DATAPUSHING } from './siSocketSt';

export function SocketApp() {
  const [ws, setWs] = useState(null)
  const [Key_Id, set_Key_Id] = useState("")
  const [data, set_data] = useState("")
  const [message, set_message] = useState("")

  useEffect(() => {
    console.log("A")
    connectWebSocket()
  }, [])

  const connectWebSocket = async () => {
    //開啟
    //setWs(webSocket(SOCKETIO_URL))
    await setWebSocketConnect(webSocket(SOCKETIO_URL))
    if (getWebSocketConnect()) {
      console.log('success connect!')
      //設定監聽
      initWebSocket()
    }
  }

  const initWebSocket = () => {
    //對 getMessage 設定監聽，如果 server 有透過 getMessage 傳送訊息，將會在此被捕捉
    getWebSocketConnect().on(IR_DATAPUSHING, message => {
      console.log(message)
      set_data(JSON.stringify( message))
    })
  }

  function getKey() {
    getWebSocketConnect().emit(IR_CREATE, {}, (Key_Id) => {
      set_Key_Id("Key_Id : " + Key_Id)
      set_data("")
    })
  }

  function send() {
    getWebSocketConnect().emit(IR_DATAPUSHING, message, (val) => {
      set_message(val)
    })
  }

  return (
    <div className="row">
      <div className="col-md-10">
        <Space />
        <Space />
        <div className="row">
          <div className="col-md-10">
            <AddButton name={"取得Key_Id"} action={getKey} />
          </div>
        </div>
        <Space />
        <div className="row">
          <div className="col-md-12" style={{ background: 'white', color: 'black', minHeight: 100 }}>
            <SingleMultilineText val={Key_Id + "\n"+data} action={set_data} />
          </div>
        </div>
      </div>
    </div>
  )
}